import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Box, Typography, Table, TableBody, TableCell, TableHead, TableRow,
  TextField, Button, useMediaQuery
} from '@mui/material';
import { useStyle } from '../../context/styleContext/styleContext';
import { toast } from 'react-hot-toast';

export default function AuthAttemptPanel() {
  const { style } = useStyle();
  const isMobile = useMediaQuery('(max-width:768px)');

  const [attempts, setAttempts] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: 'createdAt', direction: 'desc' });

  useEffect(() => {
    fetchAttempts();
  }, []);

  const fetchAttempts = async () => {
    const token = localStorage.getItem('token');
    try {
      const { data } = await axios.post('/admin/auth_attempt_info', { token });
      if (data.error) {
        toast.error(data.error);
      } else {
        setAttempts(data.attempts || []);

        console.log("attempts count ", data.attempts.length);
      }
    } catch (err) {
      console.error(err);
      toast.error('Failed to fetch login attempts.');
    }
  };

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') direction = 'desc';
    setSortConfig({ key, direction });
  };

  const filteredAttempts = attempts
    .filter((a) =>
      Object.values(a).some(
        val => val?.toString().toLowerCase().includes(searchQuery.toLowerCase())
      )
    )
    .sort((a, b) => {
      const aVal = a[sortConfig.key]?.toString().toLowerCase() || '';
      const bVal = b[sortConfig.key]?.toString().toLowerCase() || '';
      if (aVal < bVal) return sortConfig.direction === 'asc' ? -1 : 1;
      if (aVal > bVal) return sortConfig.direction === 'asc' ? 1 : -1;
      return 0;
    });

  const columns = [
    { key: 'userID', label: 'User ID' },
    { key: 'authType', label: 'Auth Type' },
    { key: 'ipAddress', label: 'IP Address' },
    { key: 'productName', label: 'Product' },
    { key: 'productVersion', label: 'Version' },
    { key: 'success', label: 'Success' },
    { key: 'responseCode', label: 'Code' },
    { key: 'message', label: 'Message' },
    { key: 'createdAt', label: 'Date' },
  ];

  return (
    <Box sx={{ padding: 2, color: style.color4, backgroundColor: 'black', minHeight: '100vh' }}>
      <Typography variant="h4" sx={{ mb: 2 }}>Login Attempt Logs</Typography>

      <TextField
        fullWidth
        placeholder="Search login attempts..."
        variant="outlined"
        sx={{ mb: 2, backgroundColor: style.color3, input: { color: style.color1 } }}
        onChange={(e) => setSearchQuery(e.target.value)}
      />

      <Table sx={{ backgroundColor: style.color2 }}>
        <TableHead>
          <TableRow>
            {columns.map(col => (
              <TableCell
                key={col.key}
                onClick={() => handleSort(col.key)}
                sx={{
                  color: style.color4,
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  borderBottom: `2px solid ${style.color1}`
                }}
              >
                {col.label} {sortConfig.key === col.key ? (sortConfig.direction === 'asc' ? '▲' : '▼') : ''}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {filteredAttempts.map((attempt, index) => (
            <TableRow key={index} sx={{ backgroundColor: style.color1 }}>
              {columns.map(col => (
                <TableCell key={col.key} sx={{ color: style.color4 }}>
                  {col.key === 'createdAt'
                    ? new Date(attempt[col.key]).toLocaleString()
                    : attempt[col.key]?.toString()}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <Button onClick={fetchAttempts} variant="outlined" sx={{ mt: 2, color: style.color4, borderColor: style.color4 }}>
        Refresh
      </Button>
    </Box>
  );
}
